$(document).ready(function() {

    setTimeout(function() {
        $('#dummy-chat-button-iframe').attr('title', 'Chat box')
    }, 2000)

    $('.table-content a').on('click', function(e) {
        e.preventDefault();
        var topSection = $($(this).attr('href'));
        $('html, body').animate({
            scrollTop: topSection.offset().top - 60
        }, 'fast');
    })
    $('#installation-guide .banner-top').insertBefore('#MainContent > div:first-child')
    $('#faq .banner-top').insertBefore('#MainContent > div:first-child')
    $('.sign-up-form-section form button').on('click', function() {
        var form = $(this).closest('form');
        var actionUrl = form.attr('data-action');
        $.ajax({
            type: "POST",
            url: actionUrl,
            data: form.serialize(),
            beforeSend: function(x) {
                x.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
            },
            success: function(data) {
                $('#popup-follow').addClass('active')
                $('body').addClass('showpoupins')
            },
            error: function(data) {
                console.log('An error occurred.');
                console.log(data);
            }
        });
    })
    $('#popup-follow_close').on('click', function(e) {
        e.preventDefault();
        $('#popup-follow').removeClass('active')
        $('body').removeClass('showpoupins')
    })
})